import { Injectable, inject } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { LoggerFactory, SportsRemoteLogger } from '@frontend/sports/common/core/feature/logging';
import { SportsProductUtils } from '@frontend/sports/host-app/sports-product/feature/utils';
import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';
import { NativeAppService, OnAppInit } from '@frontend/vanilla/core';

import { NativeEventType } from './model';

@Injectable({
    providedIn: 'root',
})
export class NativeEventSubscription implements OnAppInit {
    private nativeAppService = inject(NativeAppService);
    private redirectHelper = inject(RedirectHelperService);
    private sitecore = inject(Sitecore);
    private productUtils = inject(SportsProductUtils);

    private readonly logger: SportsRemoteLogger;

    constructor() {
        const loggerFactory = inject(LoggerFactory);

        this.logger = loggerFactory.getLogger('NativeEventSubscription');
    }

    onAppInit(): void {
        if (!this.nativeAppService.isNative) {
            return;
        }

        this.nativeAppService.eventsFromNative.pipe(this.productUtils.filterSports()).subscribe((event) => {
            try {
                switch (event.eventName.toLowerCase()) {
                    case NativeEventType.LiveAlertScreenNavigation.toLowerCase():
                        return this.redirectHelper.goToEvent({ id: this.getEventId(event.parameters), name: '' });
                    case NativeEventType.BetScreenNavigation.toLowerCase():
                    case NativeEventType.MyBetsNavigation.toLowerCase():
                        return this.redirectHelper.goToMyBets(undefined, event.parameters);
                    case NativeEventType.OpenFreeBets.toLowerCase():
                        return this.redirectHelper.goToPage(this.sitecore.crmTokens.links.promotions?.url);
                }
            } catch (error) {
                this.logger.error(error, 'Error occured while subscribing to native events.');
            }
        });
    }

    /**
     * @ngdoc function
     * @name getEventId
     * @methodOf NativeEventSubscription
     * @description Fetch event id from CCB event parameters (me : mainEventId, e : eventId, le : liveEventId, t : scoreId)
     * @private
     */
    private getEventId(parameters: any): any {
        if (parameters.t === '1' || parameters.t === '2') {
            return parameters.me;
        }

        if (parameters.le !== undefined) {
            return parameters.le;
        }

        return parameters.e;
    }
}
